import { Box, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/apploader";
import AuthBackButton from "../../../components/backButton";
import GlobalButton from "../../../components/button";
import AuthContainer from "../../../components/container/AuthContainer";
import InputField from "../../../components/InputField";
import Label from "../../../components/label";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { sendCodeUser } from "../../../services/authenticationFn";
import { forgetPasswordValidation } from "../../../utils/validation";

const ForgetPasswordPage = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputError, setInputError] = useState({
    email: false,
    isEmailValid: false,
  });

  const handleChangeInputs = (event) => {
    const { name, value } = event.target;
    setInputError((err) => ({
      ...err,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
    }));
    setEmail(value);
  };

  const handleSendCode = async () => {
    try {
      const validate = forgetPasswordValidation(email, setInputError);
      if (validate) return;

      const payload = {
        email,
        purpose: "Forget Password",
        role: "User",
      };
      setIsLoading(true);
      const response = await sendCodeUser(payload);
      if (response.data.status === "success") {
        navigate("/forget-password/verification", { state: { email } });
        showSnackbar(response.data.message, "success");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthContainer>
      <AppLoader isVisible={isLoading} />
      <AuthBackButton handleClick={() => navigate(-1)} />
      <Stack height={"400px"} justifyContent={"space-between"}>
        <Stack textAlign={"center"} mt={5}>
          <Typography variant="heading_pr" textTransform={"capitalize"}>
            {t("forgotPassword")}
          </Typography>
          <Trans i18nKey="welcomeCrm">
            Welcome to <b style={{ color: "black" }}>Market</b> CRM, Please give
            us your email address.
          </Trans>
        </Stack>
        <Box>
          <Label text={t("emailAddress")} required htmlFor="forget-email" />
          <InputField
            id={"forget-email"}
            inputError={inputError.email || inputError.isEmailValid}
            helperText={
              inputError.email
                ? t("emailAddRequired")
                : inputError.isEmailValid
                ? t("invalidEmailFormat")
                : null
            }
            placeholder={t("enterEmailAdd")}
            type="email"
            name="email"
            value={email}
            onChange={handleChangeInputs}
          />
        </Box>
        <GlobalButton
          btnText={"next"}
          handleClickBtn={handleSendCode}
          styleProps={{
            width: "100%",
            height: 50,
            mt: 4,
            fontSize: "1.125rem",
          }}
        />
      </Stack>
    </AuthContainer>
  );
};

export default ForgetPasswordPage;
